/**
 * Properties Module Configuration
 *
 * Manages properties that have, might have, or will have products/services.
 * Supports full CRUD with advanced filtering, Google Maps integration,
 * and media management.
 *
 * @see .context/WEB-APP.md for architecture documentation
 */

import type { AppModule } from '@/types/architecture'
import routes from './routes'

const propertiesModule: AppModule = {
    id: 'properties',

    navigation: {
        label: 'Properties',
        icon: 'building-2',
        path: '/properties',
        order: 10,
        moduleKey: 'properties',


        pages: [
            {
                label: 'All Properties',
                path: '/properties',
            },
            {
                label: 'Add Property',
                path: '/properties/create',
            },
            {
                label: 'Import Properties',
                path: '/imports/properties',
                icon: 'upload',
            },
            {
                label: 'Property Map',
                path: '/properties/map',
                icon: 'map',
            }
        ],
    },

    routes,
}

export default propertiesModule
